import React from "react";
import TestMainScore from "./TestMainScore";
import OtherInningsDetails from "./OtherInningsDetails";
export default class BowlerCard extends React.Component {
  render() {

    let bowlers = this.props.bowlers;
    // console.log(bowlers);
    return (


      <div className="bowlers_card_wrapp">
        <div className="batsmen_scorecard_title_text">
          <h4>Bowler</h4>
          <div className="b_scorecard_count">
            <h4 className="center">O</h4>
            <h4 className="center">M</h4>
            <h4 className="center">R</h4>
            <h4 className="center">W</h4>
            <h4 className="center wd25">ECO</h4>
          </div>
        </div>


        {bowlers && bowlers.length > 0 ?
          <div className="">
            {bowlers.map((bowlersdata, index) => {
              return (
                <div className="batsmen_scorecard_score">
                  <div className="flex_column wd50">
                    <h4 className={bowlersdata.bowling == "true" ? bowlersdata.position == 'active bowler' ? "batsmen_name text_green required" : "batsmen_name text_green" : "batsmen_name"}>{bowlersdata.name}</h4>
                  </div>
                  <div className="b_scorecard_count">
                    <h4 className="batsmen_run ">{bowlersdata.overs}</h4>
                    <h4 className="batsmen_run cue_regular">{bowlersdata.maidens}</h4>
                    <h4 className="batsmen_run cue_regular">{bowlersdata.runs_conceded}</h4>
                    <h4 className="batsmen_run cue_regular ">{bowlersdata.wickets}</h4>
                    <h4 className="batsmen_run cue_regular wd25">{bowlersdata.econ}</h4>


                  </div>
                </div>
              )
            })}

          </div>
          : ''}





      </div>

    );
  }
}
